import { render, staticRenderFns } from "./MainCont.vue?vue&type=template&id=2b682af6&scoped=true&"
import script from "./MainCont.vue?vue&type=script&lang=js&"
export * from "./MainCont.vue?vue&type=script&lang=js&"
import style0 from "./MainCont.vue?vue&type=style&index=0&id=2b682af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b682af6",
  null
  
)

export default component.exports